import { useEffect, useState } from 'react';

import { usePatchSlaSettings, useSlaSettings } from '../../hooks/use-settings';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Skeleton } from '../ui/skeleton';
import { useToast } from '../ui/toast';

export function SlaSection() {
  const { data, isLoading } = useSlaSettings();
  const patch = usePatchSlaSettings();
  const toast = useToast();
  const [warnMin, setWarnMin] = useState(30);
  const [repeatMin, setRepeatMin] = useState(120);
  const [escalateMin, setEscalateMin] = useState(240);
  const [humanIdleMin, setHumanIdleMin] = useState(180);
  const [from, setFrom] = useState('09:00');
  const [to, setTo] = useState('21:00');

  useEffect(() => {
    if (!data) return;
    setWarnMin(data.settings.warn_min);
    setRepeatMin(data.settings.repeat_min);
    setEscalateMin(data.settings.escalate_min);
    setHumanIdleMin(data.settings.human_idle_min);
    setFrom(data.settings.working_hours.from);
    setTo(data.settings.working_hours.to);
  }, [data]);

  function submit(e: React.FormEvent) {
    e.preventDefault();
    patch.mutate(
      {
        warn_min: warnMin,
        repeat_min: repeatMin,
        escalate_min: escalateMin,
        human_idle_min: humanIdleMin,
        working_hours: { tz: data?.settings.working_hours.tz ?? 'Europe/Moscow', from, to },
      },
      {
        onSuccess: () => toast.push('Настройки SLA сохранены', 'success'),
        onError: (err) => toast.push(err instanceof Error ? err.message : 'Не удалось сохранить'),
      },
    );
  }

  if (isLoading) return <Skeleton className="h-40 w-full" />;

  return (
    <form onSubmit={submit} className="grid max-w-lg grid-cols-2 gap-3 rounded border border-border p-3">
      <label className="text-xs text-muted-fg">
        Предупреждение (мин)
        <Input type="number" value={warnMin} onChange={(e) => setWarnMin(Number(e.target.value))} />
      </label>
      <label className="text-xs text-muted-fg">
        Повтор (мин)
        <Input type="number" value={repeatMin} onChange={(e) => setRepeatMin(Number(e.target.value))} />
      </label>
      <label className="text-xs text-muted-fg">
        Эскалация (мин)
        <Input type="number" value={escalateMin} onChange={(e) => setEscalateMin(Number(e.target.value))} />
      </label>
      <label className="text-xs text-muted-fg">
        Простой человека (мин)
        <Input type="number" value={humanIdleMin} onChange={(e) => setHumanIdleMin(Number(e.target.value))} />
      </label>
      <label className="text-xs text-muted-fg">
        Рабочие часы: с
        <Input value={from} onChange={(e) => setFrom(e.target.value)} />
      </label>
      <label className="text-xs text-muted-fg">
        до
        <Input value={to} onChange={(e) => setTo(e.target.value)} />
      </label>
      <Button type="submit" className="col-span-2 w-fit" disabled={patch.isPending}>
        Сохранить
      </Button>
    </form>
  );
}
